export type HexColour = `#${string}` | null;

export const PRIMARY_COLOUR: HexColour = "#17a2b8";

export const isDefaultTheme = (hex: HexColour) => {
  return hex === null || hex === PRIMARY_COLOUR;
};
